import axios from 'axios';
import user from  '../utils/user';

export default {
  async getWorkflows() {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/n8n/workflows`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createWorkflow(workflowPayload) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/n8n/workflow`,
        workflowPayload,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateWorkflow(workflowPayload) {
    try {
      const response = await axios.patch(
        `${process.env.VUE_APP_API_VIDA_URL}/n8n/workflow`,
        workflowPayload,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteWorkflow(workflowId) {
    try {
      const response = await axios.delete(
        `${process.env.VUE_APP_API_VIDA_URL}/n8n/workflow/${workflowId}`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getWorkFlowHistory(workflowId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/n8n/workflow/${workflowId}/history`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          }

        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
